var _excluded = ["size", "disabled", "onClick", "children", "LeftIcon", "RightIcon", "tabIndex", "fit", "name", "value", "className", "type"],
  _excluded2 = ["as"],
  _excluded3 = ["children"],
  _excluded4 = ["children"],
  _excluded5 = ["children"],
  _excluded6 = ["children"];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { jsxs as x, jsx as e } from "react/jsx-runtime";
import { css as l, styled as t } from "styled-components";
import { forwardRef as a } from "react";
var d = {
    xLarge: "\n    padding: 16px 40px;\n    font-size: 20px;\n    line-height: 32px;\n  ",
    large: "\n    padding: 16px 30px;\n    font-size: 18px;\n    line-height: 24px;\n  ",
    medium: "\n    padding: 12px 22px;\n    font-size: 16px;\n    line-height: 24px;\n  ",
    small: "\n    padding: 8px 20px;\n    font-size: 14px;\n    line-height: 24px;\n  ",
    xSmall: "\n    padding: 8px 16px;\n    font-size: 12px;\n    line-height: 16px;\n  "
  },
  B = l(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  && {\n    background: ", ";\n    cursor: default;\n\n    @media (hover: hover) and (pointer: fine) {\n      &:hover {\n        background: ", ";\n        text-decoration: none;\n      }\n    }\n  }\n"])), function (_ref) {
    var o = _ref.theme;
    return o.colors.black80;
  }, function (_ref2) {
    var o = _ref2.theme;
    return o.colors.black80;
  }),
  C = t.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  min-width: fit-content;\n  border-radius: 8px;\n  border: none;\n  font-weight: 700;\n  outline: none;\n  cursor: pointer;\n  white-space: nowrap;\n  user-select: none;\n  height: fit-content;\n  font-family: inherit;\n  text-decoration: none;\n  -webkit-tap-highlight-color: transparent;\n  color: ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), function (_ref3) {
    var o = _ref3.theme;
    return o.colors.black100;
  }, function (_ref4) {
    var _d$o;
    var o = _ref4.size;
    return (_d$o = d[o]) !== null && _d$o !== void 0 ? _d$o : d.small;
  }, function (_ref5) {
    var o = _ref5.disabled;
    return o && B;
  }, function (_ref6) {
    var o = _ref6.$fit;
    return o && l(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      width: fit-content;\n      height: fit-content;\n    "])));
  }),
  w = t.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  & > svg {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"])), function (_ref7) {
    var o = _ref7.$margin,
      n = _ref7.$position;
    return n === "left" ? 0 : "".concat(o, "px");
  }, function (_ref8) {
    var o = _ref8.$margin,
      n = _ref8.$position;
    return n === "right" ? 0 : "".concat(o, "px");
  }),
  u = function u(_ref9) {
    var o = _ref9.position,
      n = _ref9.Icon,
      r = _ref9.size;
    var s = y[r],
      c = ["small", "xSmall"].includes(r) ? 4 : 8;
    return n ? /* @__PURE__ */e(w, {
      $position: o,
      $margin: c,
      children: /* @__PURE__ */e(n, {
        size: s
      })
    }) : null;
  },
  i = /*#__PURE__*/a(function (_ref10, m) {
    var _ref10$size = _ref10.size,
      o = _ref10$size === void 0 ? "medium" : _ref10$size,
      _ref10$disabled = _ref10.disabled,
      n = _ref10$disabled === void 0 ? !1 : _ref10$disabled,
      r = _ref10.onClick,
      s = _ref10.children,
      c = _ref10.LeftIcon,
      p = _ref10.RightIcon,
      g = _ref10.tabIndex,
      _ref10$fit = _ref10.fit,
      h = _ref10$fit === void 0 ? !1 : _ref10$fit,
      b = _ref10.name,
      $ = _ref10.value,
      f = _ref10.className,
      _ref10$type = _ref10.type,
      v = _ref10$type === void 0 ? "button" : _ref10$type,
      k = _objectWithoutProperties(_ref10, _excluded);
    return /* @__PURE__ */x(C, _objectSpread(_objectSpread({
      size: o,
      disabled: n,
      onClick: r,
      tabIndex: g,
      $fit: h,
      name: b,
      value: $,
      className: f,
      type: v,
      ref: m
    }, k), {}, {
      children: [/* @__PURE__ */e(u, {
        Icon: c,
        size: o,
        position: "left"
      }), s, /* @__PURE__ */e(u, {
        Icon: p,
        size: o,
        position: "right"
      })]
    }));
  }),
  y = {
    xLarge: 32,
    large: 32,
    medium: 24,
    small: 16,
    xSmall: 16
  },
  I = t(i)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref11) {
    var o = _ref11.theme;
    return o.colors.blue60;
  }, function (_ref12) {
    var o = _ref12.theme;
    return o.colors.blue50;
  }),
  Q = /*#__PURE__*/a(function (_ref13, r) {
    var o = _ref13.as,
      n = _objectWithoutProperties(_ref13, _excluded2);
    return /* @__PURE__ */e(I, _objectSpread({
      ref: r,
      forwardedAs: o
    }, n));
  }),
  z = t(i)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref14) {
    var o = _ref14.theme;
    return o.colors.darkBlue40;
  }, function (_ref15) {
    var o = _ref15.theme;
    return o.colors.darkBlue30;
  }),
  U = /*#__PURE__*/a(function (o, n) {
    return /* @__PURE__ */e(z, _objectSpread({
      ref: n
    }, o));
  }),
  L = t(i)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: ", ";\n    }\n  }\n"])), function (_ref16) {
    var o = _ref16.theme;
    return o.colors.purple40;
  }, function (_ref17) {
    var o = _ref17.theme;
    return o.colors.purple30;
  }),
  V = /*#__PURE__*/a(function (o, n) {
    return /* @__PURE__ */e(L, _objectSpread({
      ref: n
    }, o));
  }),
  S = l(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  && {\n    pointer-events: none;\n    background: transparent;\n    color: ", ";\n    cursor: default;\n\n    @media (hover: hover) and (pointer: fine) {\n      &:hover {\n        background: transparent;\n      }\n    }\n\n    & > svg {\n      fill: ", ";\n    }\n  }\n"])), function (_ref18) {
    var o = _ref18.theme;
    return o.colors.black80;
  }, function (_ref19) {
    var o = _ref19.theme;
    return o.colors.black80;
  }),
  j = t(i)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: transparent;\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n  ", ";\n"])), function (_ref20) {
    var o = _ref20.theme;
    return o.colors.blue50;
  }, function (_ref21) {
    var o = _ref21.theme;
    return o.colors.blue30;
  }, function (_ref22) {
    var o = _ref22.theme;
    return o.colors.blue30;
  }, function (_ref23) {
    var o = _ref23.disabled;
    return o && S;
  }),
  D = /*#__PURE__*/a(function (o, n) {
    return /* @__PURE__ */e(j, _objectSpread({
      ref: n
    }, o));
  }),
  G = t(D)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 0;\n"]))),
  P = /*#__PURE__*/a(function (o, n) {
    return /* @__PURE__ */e(G, _objectSpread({
      ref: n
    }, o));
  }),
  W = l(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  && {\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n\n    & > svg {\n      fill: ", ";\n    }\n  }\n"])), function (_ref24) {
    var o = _ref24.theme;
    return o.colors.black80;
  }),
  A = t(i)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref25) {
    var o = _ref25.theme;
    return o.colors.blue60;
  }, function (_ref26) {
    var o = _ref26.theme;
    return o.colors.blue50;
  }, function (_ref27) {
    var o = _ref27.disabled;
    return o && W;
  }),
  X = /*#__PURE__*/a(function (_ref28, r) {
    var o = _ref28.children,
      n = _objectWithoutProperties(_ref28, _excluded3);
    return /* @__PURE__ */e(A, _objectSpread(_objectSpread({
      ref: r,
      "aria-label": "icon-button"
    }, n), {}, {
      children: o
    }));
  }),
  M = l(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  && {\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n\n    & > svg {\n      fill: ", ";\n    }\n  }\n"])), function (_ref29) {
    var o = _ref29.theme;
    return o.colors.black80;
  }),
  O = t(i)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref30) {
    var o = _ref30.theme;
    return o.colors.darkBlue40;
  }, function (_ref31) {
    var o = _ref31.theme;
    return o.colors.darkBlue30;
  }, function (_ref32) {
    var o = _ref32.disabled;
    return o && M;
  }),
  Y = /*#__PURE__*/a(function (_ref33, r) {
    var o = _ref33.children,
      n = _objectWithoutProperties(_ref33, _excluded4);
    return /* @__PURE__ */e(O, _objectSpread(_objectSpread({
      ref: r
    }, n), {}, {
      children: o
    }));
  }),
  R = l(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  && {\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n\n    & > svg {\n      fill: ", ";\n    }\n  }\n"])), function (_ref34) {
    var o = _ref34.theme;
    return o.colors.black80;
  }),
  T = t(i)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref35) {
    var o = _ref35.theme;
    return o.colors.purple40;
  }, function (_ref36) {
    var o = _ref36.theme;
    return o.colors.purple30;
  }, function (_ref37) {
    var o = _ref37.disabled;
    return o && R;
  }),
  Z = /*#__PURE__*/a(function (_ref38, r) {
    var o = _ref38.children,
      n = _objectWithoutProperties(_ref38, _excluded5);
    return /* @__PURE__ */e(T, _objectSpread(_objectSpread({
      ref: r
    }, n), {}, {
      children: o
    }));
  }),
  q = l(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  && {\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_ref39) {
    var o = _ref39.theme;
    return o.colors.black100;
  }, function (_ref40) {
    var o = _ref40.theme;
    return o.colors.black100;
  }),
  E = t(i)(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  color: ", ";\n  background: ", ";\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      color: ", ";\n      background: ", ";\n    }\n  }\n\n  ", ";\n"])), function (_ref41) {
    var o = _ref41.theme;
    return o.colors.blue50;
  }, function (_ref42) {
    var o = _ref42.theme;
    return o.colors.blue95;
  }, function (_ref43) {
    var o = _ref43.theme;
    return o.colors.blue30;
  }, function (_ref44) {
    var o = _ref44.theme;
    return o.colors.blue90;
  }, function (_ref45) {
    var o = _ref45.disabled;
    return o && q;
  }),
  _ = /*#__PURE__*/a(function (o, n) {
    return /* @__PURE__ */e(E, _objectSpread({
      ref: n
    }, o));
  }),
  F = l(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  && {\n    background: transparent;\n\n    &:hover {\n      background: transparent;\n    }\n\n    & > svg {\n      fill: ", ";\n    }\n  }\n"])), function (_ref46) {
    var o = _ref46.theme;
    return o.colors.black80;
  }),
  H = t(i)(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  background: transparent;\n  width: fit-content;\n  padding: 0;\n\n  & > svg {\n    fill: ", ";\n  }\n\n  @media (hover: hover) and (pointer: fine) {\n    &:hover {\n      background: transparent;\n\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n\n  ", ";\n"])), function (_ref47) {
    var o = _ref47.theme;
    return o.colors.blue95;
  }, function (_ref48) {
    var o = _ref48.theme;
    return o.colors.blue90;
  }, function (_ref49) {
    var o = _ref49.disabled;
    return o && F;
  }),
  oo = /*#__PURE__*/a(function (_ref50, r) {
    var o = _ref50.children,
      n = _objectWithoutProperties(_ref50, _excluded6);
    return /* @__PURE__ */e(H, _objectSpread(_objectSpread({
      ref: r
    }, n), {}, {
      children: o
    }));
  }),
  no = t(P)(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1;\n  ", ";\n"])), function (_ref51) {
    var o = _ref51.theme,
      n = _ref51.$danger;
    return n && l(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n      color: ", ";\n\n      &:hover {\n        color: ", ";\n      }\n\n      @media (hover: none) {\n        &:hover {\n          color: ", ";\n        }\n      }\n    "])), o.colors.red60, o.colors.red40, function (_ref52) {
      var r = _ref52.theme;
      return r.colors.red60;
    });
  });
export { Q as BlueButton, X as BlueIconButton, i as Button, U as DarkBlueButton, Y as DarkBlueIconButton, y as IconSize, _ as LightBlueButton, oo as LightBlueIconButton, P as LinkButton, no as OptionButton, V as PurpleButton, Z as PurpleIconButton, D as TextButton };